module.exports = __webpack_public_path__ + "static/work38-bd4ebccb8433f3cbfbadfad69d80d681.jpg";